import faLocale from './langs/fa'
import enLocale from './langs/en'
import {qt, use, add} from './locale'

use('fa', faLocale);
use('en', enLocale);

export default {use, qt, add};